export default "__VITE_ASSET__eef02877__"